module.exports = __webpack_public_path__ + "img/TDSouthAfrica-white.2602a0e8.svg";